import { CHANGE_PAYMENT_ADDRESS_ID } from '../actions/payment';

const initial_state = {
  address_id: null
};

const reducer = (state = initial_state, action) => {
  switch (action.type) {
    case CHANGE_PAYMENT_ADDRESS_ID:
      return { ...state, address_id: action.payload };
    default:
      return state;
  }
};

export default reducer;
